export default {"src":"/_next/static/media/arrow-right.b08d8b66.svg","height":24,"width":24};